module.exports = __webpack_public_path__ + "static/media/new-cart-icon.33c8d2a7.svg";